export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export interface EmailValidationResult {
  valid: boolean;
  error?: string;
  trimmed: string;
}

export function validateEmail(value: string): EmailValidationResult {
  const trimmed = value.trim();

  if (!trimmed) {
    return { valid: false, error: 'Email is required', trimmed };
  }

  if (!EMAIL_REGEX.test(trimmed)) {
    return { valid: false, error: 'Please enter a valid email address', trimmed };
  }

  return { valid: true, trimmed };
}
